import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { init } from "ityped";

gsap.registerPlugin(ScrollTrigger);

export function textAnimation() {
    const targets = [...document.querySelectorAll("[data-text-animation]")];

    function splitIn(elm, mode) {
        const txts = [...elm.querySelectorAll(".c-splittxt")];

        if (mode === "random") {
            txts.forEach((txt, index) => {
                setTimeout(() => {
                    txt.setAttribute("data-active", "1");
                }, Math.random() * 750);
            });
        } else {
            txts.forEach((txt, index) => {
                setTimeout(() => {
                    txt.setAttribute("data-active", "1");
                }, index * 100);
            });
        }
    }

    function typeCatch(tgt) {
        let txt = tgt.getAttribute("data-typetxt");
        txt = txt.replaceAll("<br/>", "\n");
        init(tgt, { showCursor: false, strings: [txt], loop: false, disableBackTyping: false, typeSpeed: 70 });
    }

    for (const el of targets) {
        ScrollTrigger.create({
            trigger: el,
            start: "top 85%",
            // markers: true,
            onEnter: () => {
                if (el.getAttribute("data-typed") === "1" && el.getAttribute("data-typeend") !== "1") {
                    typeCatch(el);
                    el.setAttribute("data-typeend", "1");
                }

                if (el.getAttribute("data-splittxt") === "1") {
                    const mode = el.getAttribute("data-sectionttl") === "1" ? "none" : "random";
                    splitIn(el, mode);
                }
            },
        });
    }
}
